<template>
  <svg
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      clip-rule="evenodd"
      d="M21.667 20.667c0 .736-.597 1.333-1.334 1.333h-16A1.333 1.333 0 0 1 3 20.667V3.333C3 2.597 3.597 2 4.333 2h13.374c.348 0 .682.136.931.379l2.626 2.562c.258.251.403.596.403.955v14.77Z"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M7.04 8.667h10.667M7.04 12.667h10.667M7.04 16.667h5.333"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
